import { FunctionComponent } from 'react';

import isEmpty from 'lodash/isEmpty';

import { useAuth } from '@sbv-clients/shared-feature-auth';
import {
  AppBar,
  Box,
  IconButton,
  useTheme,
  Icon,
} from '@sbv-clients/ui-shared';

import BreadCrumbs from './bread-crumb';
import {
  ImpersonatedLabel,
  ImpersonatedLabelMobileView,
} from './impersonated-label';
import { NavbarProps } from './typings/navbar-props';
import { UserDropdown } from './user-dropdown';

export const Navbar: FunctionComponent<NavbarProps> = ({
  onToggleDrawer,
  ssoUserName,
  breadCrumbLabels,
  extraMenuItems,
}) => {
  const { impersonatorId } = useAuth();
  const theme = useTheme();
  return (
    <AppBar
      position="sticky"
      elevation={0}
      sx={{
        borderBottom: `1px solid ${theme.border?.profileTitle}`,
        backgroundColor: 'white',
      }}
    >
      <Box
        sx={{
          position: 'relative',
          padding: { xs: '0 12px', md: '0 24px' },
          height: '60px',
          alignItems: 'center',
          display: 'flex',
        }}
      >
        <Box sx={{ display: { xs: 'none', md: 'block' } }}>
          {!isEmpty(impersonatorId) && <ImpersonatedLabel />}
        </Box>
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          color="black"
          width="100%"
          minHeight="60px"
          gap={1}
        >
          <Box
            display="flex"
            alignItems="center"
            minWidth={0}
            overflow="hidden"
            flex={1}
          >
            <IconButton
              sx={{
                display: { xs: 'block', md: 'none' },
                lineHeight: 0.5,
                mr: 2,
                flexShrink: 0,
              }}
              size="medium"
              color="inherit"
              aria-label="Open drawer"
              onClick={onToggleDrawer}
            >
              <Icon name={'Menu'} />
            </IconButton>
            <Box minWidth={0} overflow="hidden" width="100%">
              <BreadCrumbs breadCrumbLabels={breadCrumbLabels} />
            </Box>
          </Box>
          <Box
            display="flex"
            alignItems="center"
            flexShrink={0}
            columnGap={{ xs: 1, md: 3 }}
          >
            <Box sx={{ display: { xs: 'block', md: 'none' } }}>
              {!isEmpty(impersonatorId) && <ImpersonatedLabelMobileView />}
            </Box>
            <UserDropdown
              ssoUserName={ssoUserName}
              extraMenuItems={extraMenuItems}
            />
          </Box>
        </Box>
      </Box>
    </AppBar>
  );
};
